export default function PHP_libxml_use_internal_errors() {
  return (
    <div>
      <h1>PHP_libxml_use_internal_errors</h1>
    </div>
  );
}
